import {useEffect, useState} from "react";
import {logout} from "dataLayer/apisWithoutCache/slr/logout";
import {IMember} from "../screens/AccountMembership/_private/types/midView";
import {CookiesConstants} from "utils/constants";
import {parseCookies} from "utils/nookies";
import {destroyLocalStorageAuthUser} from "dataLayer/localStorage/localStorageMember";

export function useLogout(memberDataDefault: IMember) {
    const [memberData, setMemberData] = useState<IMember>(memberDataDefault);
    //todo @abdulraheem move this function to useLocalStorage in varnish ticket

    useEffect(() => {
        setMemberData(memberDataDefault);
    }, [JSON.stringify(memberDataDefault)]);

    const logoutProcess = async () => {
    const cookies = parseCookies();
    const fcmToken = cookies[CookiesConstants.FIREBASE_FCM_TOKEN] ?? null;
        if (memberData) {
            await logout(fcmToken)
                .then(() => {
                    destroyLocalStorageAuthUser(); // this will trigger event "on-logout-success"
                })
                .catch((e) => {
                    console.warn("trace->Logout Api Error", e.message);
                });
        } else {
            console.warn("Logout called for non-loggedin user");
        }
    };
const logoutEvent =()=> {
    logoutProcess().then(() => {
        console.log('logoutProcess')
    })
}
    useEffect(() => {
        if (window.location.href.includes("source=logout")) {
            logoutProcess().then(() => {
                const href = window.location.href;
                const url = href.split("?source=logout");
                history.replaceState(null, null, url[0]);
            });
        }
    }, []);
    useEffect(() => {
        document.addEventListener('logout',logoutEvent)
        return () =>
            document.removeEventListener('logout', logoutEvent);
    }, []);
}
